import React, { useState } from "react";
import useViewController from "./viewController";
import ActionStatus from "../../components/ActionStatus";
import BaseButton from "../../components/BaseButton";
import BaseForm from "../../components/BaseForm";
import providers from "../../lib/providers";
import { I18n, t } from "../../locales";
import "./style.scss";

interface Props {
  onClose: () => void;
}

export default function ModalContactUs({ onClose }: Props) {
  const [processing, setProcessing] = useState(false);
  const [showSuccessStatus, setShowSuccessStatus] = useState(false);
  const { values, setValues, fields, errors, setErrors, isValid } = useViewController();

  const onCloseModal = () => {
    setValues({});
    setShowSuccessStatus(false);
    onClose();
  };

  const onSubmit = async () => {
    if (!isValid) {
      return;
    }

    const data = {
      name: values.name,
      email: values.email,
      message: values.message,
    };

    try {
      setProcessing(true);
      await providers.ContactUsProvider.contactUs({ data });
      setShowSuccessStatus(true);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <>
      {showSuccessStatus ? (
        <ActionStatus
          status="success"
          title={t("Thank you for contacting support!")}
          className="modal-contact-us__success"
          description={t("We will contact you as soon as possible.")}
        >
          <BaseButton className="mt-6" name="awesome" onClick={onCloseModal} fluid large>
            {t("Awesome")}
          </BaseButton>
        </ActionStatus>
      ) : (
        <div>
          <div className="headline-1 text-center mb-2">Contact Us</div>
          <div className="text-center mb-8">
            <I18n
              path="Please fill in the form below and <mail>support@securetheoffer.com</mail> will contact you."
              components={{
                mail: (
                  <a className="modal-contact-us__link" href="mailto:support@securetheoffer.com">
                    mail
                  </a>
                ),
              }}
            />
          </div>

          <BaseForm
            className="modal-contact-us__form"
            fields={fields}
            values={values}
            onChange={setValues}
            errors={errors}
            setErrors={setErrors}
            onSubmitEnter={onSubmit}
          >
            <BaseButton className="mt-8 ml-auto" large loading={processing} disabled={!isValid} onClick={onSubmit}>
              {t("Submit")}
            </BaseButton>
          </BaseForm>
        </div>
      )}
    </>
  );
}
